import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CategoriesApi } from '../../apis';
import { QueryKeys } from '../query-keys';

const useDeleteCategory = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (id: string) => CategoriesApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CATEGORIES] });
    },
  });

  return {
    deleteCategory: mutation.mutateAsync,
    isDeleting: mutation.isPending,
    wasDeletedWithSuccess: mutation.isSuccess,
    wasDeletedWithoutSuccess: mutation.isError,
  };
};

export default useDeleteCategory;
